<template>
  <div id="menu-wrapper" :class="[ {'active' : mobileMenuStatus}, loadedPage]">
    <div class="menu" v-if="loadedPage != 'projet'">
      <a href="javascript:void(0);" id="trigger" @click="menuToggle">Menu</a>
      <ul class="main-menu">
        <li class="main-menu-li" ><a href="javascript:void(0);" v-scroll-to="'.atelier'" @click="scrollToEl('.atelier')">Atelier</a></li>
        <li class="main-menu-li" ><a href="javascript:void(0);" v-scroll-to="'.equipe'" @click="scrollToEl('.equipe')">{{ $t('Equipe') }}</a></li>
        <li  class="main-menu-li" v-if="loadedPage !== 'projets'"><router-link to="/projets">{{ $t('Projets') }}</router-link></li>
        <li class="main-menu-li" ><a href="javascript:void(0);" v-scroll-to="'footer'" @click="contactClicked()">{{ $t('Contact') }}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Power4 } from 'gsap';
import store from '@/store/store';

export default {
  name: 'MenuComponent',
  methods: {
    menuToggle() {
      store.commit('menuToggle');
    },
    scrollToEl(element) {
      if (element === '.atelier') {
        store.commit('showAtelier', true);
      } else {
        store.commit('showTeam', true);
      }
      store.commit('menuToggle', 'close');
      if (this.loadedPage !== 'home') {
        store.commit('scrolltoElement', element);
        this.$router.push('/');
      }
    },
    animateMenu() {
      if (this.loadedPage !== 'projet') {
        const tl = new TimelineMax();
        if (this.mobileMenuStatus) {
          // open animation
          tl.staggerFromTo('li.main-menu-li', 0.3, { autoAlpha: 0, y: -20 }, { autoAlpha: 1, y: 0, ease: Power4.easeOut }, 0.04, 0.1);
        } else {
          // close animation
          tl.staggerTo('li.main-menu-li', 0.3, { autoAlpha: 0, y: -20, ease: Power4.easeOut }, 0.04, 0.1);
        }
      }
    },
    contactClicked() {
      store.commit('menuToggle', 'close');
    },
  },
  computed: {
    loadedPage() {
      return store.state.loadedPage;
    },
    mobileMenuStatus() {
      return store.state.mobileMenuStatus;
    },
  },
  mounted() {
    this.animateMenu();
  },
  watch: {
    mobileMenuStatus() {
      this.animateMenu();
    },
    $route() {
      this.animateMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
#trigger {
  margin-bottom: 10px;
}
#menu-wrapper {
  position: fixed;
  z-index: 0;
  top: 95px;
  right: 10%;
  @include md {
    top: 85px;
  }
  @include sm {
    top: 74px;
    right: 3%;
  }
  // =====================================================
  // regular menu
  // =====================================================
  .menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      pointer-events: none;
    }
  }
  &:not(.active) {
    .menu ul li {
      opacity: 0;
    }
  }
  &.active {
    .menu {
      ul {
        pointer-events: auto;
      }
    }
  }
  // =====================================================
  // single project nav
  // removed, created another component
  // =====================================================
  &.projet {
    display: none;
  }
  // =====================================================
  // projects page special
  // =====================================================
  &.projets {
    top: 172px;
    right: calc(10% - 50px);
    min-width: 100px;
    @include md {
      top: 168px;
    }
    @include sm {
      top: 155px;
    }
    @include xs {
      top: 122px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/MenuComponent.vue